import { useTranslation } from "react-i18next"
import { ReactNode } from "react"

export const FunctionsComponent = () => {
  const { t } = useTranslation("Functions")

  const functions: {
    name: ReactNode
    desc: ReactNode
    icon: ReactNode
  }[] = [
    { name: t("Tor o długości do 6,00m"), desc: t("Tor o długości do 6,00m.Description"), icon: (<span className="block w-18 h-18 font-icon text-7xl/none text-aluprofil-gray">&#xe013;</span>) },
    { name: t("Profile w kolorystyce RAL"), desc: t("Profile w kolorystyce RAL.Description"), icon: (<span className="block w-18 h-18 font-icon text-7xl/none text-aluprofil-gray">&#xe00d;</span>) },
    { name: t("Rączka z okleiną PCV"), desc: t("Rączka z okleiną PCV.Description"), icon: (<span className="block w-18 h-18 font-icon text-7xl/none text-aluprofil-gray">&#xe00f;</span>) },
    { name: t("Profile z folią drewnopodobną"), desc: t("Profile z folią drewnopodobną.Description"), icon: (<span className="block w-18 h-18 font-icon text-7xl/none text-aluprofil-gray">&#xe00e;</span>) },
    { name: t("Łączniki dla szkła do 8mm"), desc: t("Łączniki dla szkła do 8mm.Description"), icon: (<span className="block w-18 h-18 font-icon text-7xl/none text-aluprofil-gray">&#xe00c;</span>) },
    { name: t("Łączniki dla płyty do 18mm"), desc: t("Łączniki dla płyty do 18mm.Description"), icon: (<span className="block w-18 h-18 font-icon text-7xl/none text-aluprofil-gray">&#xe00b;</span>) },
    { name: t("Głębokość systemu już od 56mm"), desc: t("Głębokość systemu już od 56mm.Description"), icon: (<span className="block w-18 h-18 font-icon text-7xl/none text-aluprofil-gray">&#xe00a;</span>) },
    { name: t("Samodomykacze skrajne"), desc: t("Samodomykacze skrajne.Description"), icon: (<span className="block w-18 h-18 font-icon text-7xl/none text-aluprofil-gray">&#xe010;</span>) },
    { name: t("Samodomykacz środkowy"), desc: t("Samodomykacz środkowy.Description"), icon: (<span className="block w-18 h-18 font-icon text-7xl/none text-aluprofil-gray">&#xe011;</span>) },
    { name: t("Drzwi przesuwne do 3,50m wysokości"), desc: t("Drzwi przesuwne do 3,50m wysokości.Description"), icon: (<span className="block w-18 h-18 font-icon text-7xl/none text-aluprofil-gray">&#xe009;</span>) },
    { name: t("Tory dolne licowane z powierzchnią"), desc: t("Tory dolne licowane z powierzchnią.Description"), icon: (<span className="block w-18 h-18 font-icon text-7xl/none text-aluprofil-gray">&#xe012;</span>) },
    { name: t("Dożywotnia gwarancja na układy jezdne"), desc: t("Dożywotnia gwarancja na układy jezdne.Description"), icon: (<span className="block w-18 h-18 font-icon text-7xl/none text-aluprofil-gray">&#xe008;</span>) },
  ]

  return (
    <div className="w-full bg-white">
      <div className="mx-auto container">
        <div className="px-4 py-16">
          <hr className="mb-16 border-t-2 border-aluprofil-gray/20" />

          <h2 className="mb-16 w-full font-head font-normal text-5xl text-aluprofil-gray">
            {t("Funkcje")}
          </h2>

          <div className="grid grid-cols-1 flex-wrap gap-x-6 gap-y-16 md:grid-cols-2 lg:grid-cols-3">
            {functions.map(
                (func, index) => (
                  <div key={index} className="flex flex-col gap-4">
                    <div className="w-18 h-18">
                      {func.icon}
                    </div>

                    <div className="h-20 relative font-head font-bold text-2xl text-aluprofil-gray after:content-[''] after:absolute after:left-0 after:bottom-0 after:mt-4 after:w-12 after:h-0.25 after:block after:border-b after:border-b-aluprofil-red">
                      {func.name}
                    </div>

                    <div className="text-base text-aluprofil-gray">
                      {func.desc}
                    </div>
                  </div>
                )
              )
            }
          </div>
        </div>
      </div>
    </div>
  )
}
